import { Box, Button, SpaceBetween } from '@amzn/awsui-components-core';
import React, { useMemo, useState } from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import { base64toBlob } from '../utils/PDFUtils';
import { TiptapOutputType } from '@amzn/awscat-editor';

interface Props {
  title: TiptapOutputType;
  contentId: string;
  workflowId?: number;
}

const DownloadPdfButton: React.FunctionComponent<Props> = (props: Props) => {
  const { title, contentId, workflowId } = props;
  const mplService: IMplServiceClient = useMemo(() => MplServiceClientFactory.create(), []);
  const [isDownloadingPdf, setIsDownloadingPdf] = useState<boolean>(false);

  const handleDownloadPDF = async () => {
    setIsDownloadingPdf(true);
    try {
      const { preSignedUrl } = await mplService.getPublicationPDF(contentId, workflowId);
      window.open(preSignedUrl);
    } catch (err) {
      // tslint:disable-next-line: no-console
      console.error(err);
    } finally {
      setIsDownloadingPdf(false);
    }
  };

  return (
    <Box padding={{ top: 'xl' }}>
      <SpaceBetween direction="horizontal" size="xxxs">
        <Button
          iconName="download"
          variant="icon"
          ariaLabel="Download PDF"
          loading={isDownloadingPdf}
          onClick={handleDownloadPDF}
        />
        <Box fontWeight="bold" fontSize="heading-m" variant="p" color="text-body-secondary">
          PDF
        </Box>
      </SpaceBetween>
    </Box>
  );
};

export default DownloadPdfButton;
